module.exports = __webpack_public_path__ + "media/five_columns_long.8335e805.wav";